import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
    {
        id: "po-07-h7v0-01",
        name: "PO 01 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "2", x: 44, y: 232, width: 280, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 414, width: 280, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 232, width: 280, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 332, y: 414, width: 280, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 736, y: 175, width: 490, height: 310, rotation: 0, imageRotation: 0 },
            { id: "6", x: 736, y: 492, width: 242, height: 154, rotation: 0, imageRotation: 0 },
            { id: "7", x: 986, y: 492, width: 241, height: 154, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-02",
        name: "PO 02 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 67, y: 247, width: 521, height: 325, rotation: 0, imageRotation: 0 },
            { id: "2", x: 729, y: 165, width: 257, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 331, width: 257, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 729, y: 496, width: 257, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 994, y: 165, width: 257, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 994, y: 331, width: 257, height: 157, rotation: 0, imageRotation: 0 },
            { id: "7", x: 994, y: 496, width: 257, height: 157, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-03",
        name: "PO 03 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 63, y: 176, width: 558, height: 347, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 63, y: 530, width: 181, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 252, y: 530, width: 181, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 441, y: 530, width: 181, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 149, width: 558, height: 337, rotation: 0, imageRotation: 0 },
            { id: "6", x: 707, y: 493, width: 276, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 991, y: 493, width: 275, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-04",
        name: "PO 04 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 42, y: 232, width: 572, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 697, y: 232, width: 186, height: 113, rotation: 0, imageRotation: 0 },
            { id: "3", x: 697, y: 353, width: 186, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 697, y: 474, width: 186, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 891, y: 232, width: 185, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1084, y: 232, width: 185, height: 113, rotation: 0, imageRotation: 0 },
            { id: "7", x: 891, y: 353, width: 378, height: 234, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-05",
        name: "PO 05 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 73, y: 158, width: 579, height: 350, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 158, width: 578, height: 350, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 515, width: 227, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 308, y: 515, width: 227, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 543, y: 515, width: 227, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 778, y: 515, width: 226, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1012, y: 515, width: 226, height: 146, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-06",
        name: "PO 06 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 57, y: 188, width: 294, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 359, y: 188, width: 294, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 661, y: 188, width: 293, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 962, y: 188, width: 293, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 57, y: 382, width: 394, height: 249, rotation: 0, imageRotation: 0 },
            { id: "6", x: 459, y: 382, width: 394, height: 249, rotation: 0, imageRotation: 0 },
            { id: "7", x: 861, y: 382, width: 394, height: 249, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-07",
        name: "PO 07 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
        size: [1311, 820],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 197, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 342, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 487, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 220, y: 487, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 440, y: 487, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 220, y: 197, width: 432, height: 282, rotation: 0, imageRotation: 0 },
            { id: "7", x: 660, y: 197, width: 651, height: 426, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-08",
        name: "PO 08 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 197, width: 652, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 197, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 342, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 487, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 880, y: 487, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1100, y: 487, width: 211, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 880, y: 197, width: 431, height: 282, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-09",
        name: "PO 09 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 197, width: 652, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 197, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 880, y: 197, width: 212, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1100, y: 197, width: 211, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1100, y: 342, width: 211, height: 137, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1100, y: 487, width: 211, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 660, y: 342, width: 432, height: 282, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-10",
        name: "PO 10 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
        size: [1252, 783],
        style: {},
        slots: [           
            { id: "1", x: 51, y: 177, width: 245, height: 150, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 335, width: 245, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 51, y: 493, width: 245, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 304, y: 177, width: 704, height: 466, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1015, y: 177, width: 244, height: 150, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1015, y: 335, width: 244, height: 150, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1015, y: 493, width: 244, height: 150, rotation: 0, imageRotation: 0 }
        ],
    }
];